import { ActionType } from 'typesafe-actions'
import * as actions from './actions'

export type AuthAction =
  | ActionType<typeof actions.createAccountRequest>
  | ActionType<typeof actions.createAccountSuccess>
  | ActionType<typeof actions.createAccountFail>
  | ActionType<typeof actions.loginRequest>
  | ActionType<typeof actions.loginSuccess>
  | ActionType<typeof actions.loginFail>
  | ActionType<typeof actions.getVerificationRequest>
  | ActionType<typeof actions.getVerificationSuccess>
  | ActionType<typeof actions.getVerificationFail>
  | ActionType<typeof actions.resendCodeRequest>
  | ActionType<typeof actions.resendCodeSuccess>
  | ActionType<typeof actions.resendCodeFail>
  | ActionType<typeof actions.fetchTermConditionsRequest>
  | ActionType<typeof actions.fetchTermConditionsSuccess>
  | ActionType<typeof actions.fetchTermConditionsFail>
  | ActionType<typeof actions.resetPasswordRequest>
  | ActionType<typeof actions.resetPasswordSuccess>
  | ActionType<typeof actions.resetPasswordFail>
  | ActionType<typeof actions.changePasswordRequest>
  | ActionType<typeof actions.changePasswordSuccess>
  | ActionType<typeof actions.changePasswordFail>
  | ActionType<typeof actions.logout>
  | ActionType<typeof actions.clearRegistrationData>
  | ActionType<typeof actions.authenticated>
  | ActionType<typeof actions.admin>
  | ActionType<typeof actions.restPasswordRequest>
  | ActionType<typeof actions.restPasswordSuccess>
  | ActionType<typeof actions.restPasswordFail>
  | ActionType<typeof actions.changePasswordByEmailRequest>
  | ActionType<typeof actions.changePasswordByEmailSuccess>
  | ActionType<typeof actions.changePasswordByEmailFail>
  | ActionType<typeof actions.setEmilToStore>

export interface AuthState {
  errors: {
    changePassword?: string | null
    resetPassword?: string | null
  }
  isAuthenticated: boolean
  isFetchingRegistration: boolean
  isFetchingLoggedIn: boolean
  isFetchingVerification: boolean
  isPasswordChanging: boolean
  registrationData: object | null
  identity: number | null
  isAdmin: boolean
  publicEmail?: string
}

export enum AuthActionTypes {
  CREATE_ACCOUNT_REQUEST = '@@auth/CREATE_ACCOUNT_REQUEST',
  CREATE_ACCOUNT_SUCCESS = '@@auth/CREATE_ACCOUNT_SUCCESS',
  CREATE_ACCOUNT_FAIL = '@@auth/CREATE_ACCOUNT_FAIL',
  LOGIN_REQUEST = '@@auth/LOGIN_REQUEST',
  LOGIN_SUCCESS = '@@auth/LOGIN_SUCCESS',
  LOGIN_FAIL = '@@auth/LOGIN_FAIL',
  GET_VERIFICATION_REQUEST = '@@auth/GET_VERIFICATION_REQUEST',
  GET_VERIFICATION_SUCCESS = '@@auth/GET_VERIFICATION_SUCCESS',
  GET_VERIFICATION_FAIL = '@@auth/GET_VERIFICATION_FAIL',
  RESEND_CODE_REQUEST = '@@auth/RESEND_CODE_REQUEST',
  RESEND_CODE_SUCCESS = '@@auth/RESEND_CODE_SUCCESS',
  RESEND_CODE_FAIL = '@@auth/RESEND_CODE_FAIL',
  FETCH_TERMS_CONDITIONS_REQUEST = '@@auth/FETCH_TERMS_CONDITIONS_REQUEST',
  FETCH_TERMS_CONDITIONS_SUCCESS = '@@auth/FETCH_TERMS_CONDITIONS_SUCCESS',
  FETCH_TERMS_CONDITIONS_FAIL = '@@auth/FETCH_TERMS_CONDITIONS_FAIL',
  RESET_PASSWORD_REQUEST = '@@auth/RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS = '@@auth/RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAIL = '@@auth/RESET_PASSWORD_FAIL',
  CHANGE_PASSWORD_REQUEST = '@@auth/CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_SUCCESS = '@@auth/CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAIL = '@@auth/CHANGE_PASSWORD_FAIL',
  LOGOUT = '@@auth/LOGOUT',
  CLEAR_REGISTRATION_DATA = '@@auth/CLEAR_REGISTRATION_DATA',
  AUTHENTICATED = '@@auth/AUTHENTICATED',
  ADMIN = '@@auth/ADMIN',
  REST_PASSWORD_REQUEST = '@@forgotPassword/REST_PASSWORD_REQUEST',
  REST_PASSWORD_SUCCESS = '@@forgotPassword/REST_PASSWORD_SUCCESS',
  REST_PASSWORD_FAIL = '@@forgotPassword/REST_PASSWORD_FAIL',
  CHANGE_PASSWORD_BY_EMAIL_REQUEST = '@@forgotPassword/CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_BY_EMAIL_SUCCESS = '@@forgotPassword/CHANGE_PASSWORD_BY_EMAIL_SUCCESS',
  CHANGE_PASSWORD_BY_EMAIL_FAIL = '@@forgotPassword/CHANGE_PASSWORD_BY_EMAIL_FAIL',
  SET_EMAIL_TO_STORE = '@@public/SET_EMAIL_TO_STORE'
}

export interface AccountPayloadType {
  email: string
  firstName: string
  middleInitial?: string
  lastName: string
  mobileNumber?: string
  password: string
  confirmPassword?: string
  termsAndConditionsId: number
  ipAddress?: string
  isChecked?: boolean
}

export interface ILoginPayload {
  userName?: string
  password?: string
  rememberMe?: boolean
}

export interface ILoginResponse {
  access_token: string
  expires_in?: number
  identity: number
  refresh_token?: string
  token_type?: string
}